import React, { useContext, useState, useEffect } from "react";
import { Col, Row, Form, InputGroup, Button } from "react-bootstrap";
import { GlobalContext } from "../Context/GlobalState";
import loaderGif from "../seoimages/aiload.gif";
import { BASE_URL_API_TRANXT_API } from "../utils/Constant";
import "bootstrap/dist/css/bootstrap.min.css";
import { basicAuth } from "../utils/Credentials";
const Support = () => {
  const WS_URL = "wss://blogapi.bumppy.com/ws/admin-chat";
  const WS_USER_LIST_URL = "wss://blogapi.bumppy.com/ws/admin-chat-list";
  const socketRef = React.useRef(null);
  const userListSocketRef = React.useRef(null);
  const lastMessageRef = React.useRef("");
  const { password, username } = basicAuth;
  const base64Credentials = btoa(`${username}:${password}`);
  const { setTransactionLoaderState, user } = useContext(GlobalContext);
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState();
  const [inputMessage, setInputMessage] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const connectWebSocket = (mobile) => {
    if (socketRef.current) {
      socketRef.current.close();
      socketRef.current = null;
    }
    const socket = new WebSocket(WS_URL);
    socketRef.current = socket;
    socket.onopen = () => {
    };
    socket.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        if (msg?.type === "NEW_CHAT" && msg?.data?.mobile === mobile) {
          const uniqueKey = msg.data.lastMessage + msg.data.time;
          if (lastMessageRef.current === uniqueKey) return;
          lastMessageRef.current = uniqueKey;
          setMessages((prev = []) => [
            ...prev,
            {
              sender: msg.data.type,
              text: msg.data.lastMessage,
              time: msg.data.time,
            },
          ]);
        }
      } catch (err) {
      }
    };
    socket.onerror = (err) => {
    };
    socket.onclose = () => {
      socketRef.current = null;
    };
  };
  const connectUserListWebSocket = () => {
    if (userListSocketRef.current) return;
    const socket = new WebSocket(WS_USER_LIST_URL);
    userListSocketRef.current = socket;
    socket.onopen = () => {
    };
    socket.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        if (msg?.type === "CHAT_LIST") {
          getChatUserList();
        }
      } catch (err) {
      }
    };
    socket.onerror = () => {};
    socket.onclose = () => {
      userListSocketRef.current = null;
    };
  };
  const getChatUserList = async () => {
    setTransactionLoaderState(true);
    setLoading(true);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userid: user.user_id }),
      };
      const response = await fetch(
        `${BASE_URL_API_TRANXT_API}/api/Support/getAdminChatUserList`,
        requestOptions
      );
      const data = await response.json();
      if (data.responseCode === "00") {
        setUserList(data.response);
        const firstUser = data.response[0];
        setSelectedUser(firstUser);
        getSupportChatsAdmin(firstUser.user_mobile);
      }
    } catch (error) {
    } finally {
      setTransactionLoaderState(false);
      setLoading(false);
    }
  };
  const getSupportChatsAdmin = async (mobile) => {
    setTransactionLoaderState(true);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mobile, message: "" }),
      };
      const response = await fetch(
        `${BASE_URL_API_TRANXT_API}/api/Support/getSupportChatsAdmin`,
        requestOptions
      );

      const data = await response.json();
      if (data.responseCode === "00" && Array.isArray(data.response)) {
        const formattedMessages = data.response.map((msg) => ({
          sender: msg.type,
          text: msg.message,
          time: msg.datetime,
        }));
        setMessages(formattedMessages);
      } else {
        setMessages([]);
      }
    } catch (error) {
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const sendSupportChatAdmin = async (mobile, message) => {
    setTransactionLoaderState(true);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mobile, message }),
      };
      const response = await fetch(
        `${BASE_URL_API_TRANXT_API}/api/Support/sendSupportChatAdmin`,
        requestOptions
      );
      const data = await response.json();
      return data;
    } catch (error) {
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const filteredUserList = (userList || []).filter(
    (u) =>
      (u?.user_name?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
      (u?.user_id?.toString() || "").includes(searchQuery)
  );
  useEffect(() => {
    getChatUserList();
  }, []);
  const handleSend = async () => {
    if (!inputMessage?.trim() || !selectedUser?.user_mobile) return;
    const message = inputMessage.trim();
    setInputMessage("");
    await sendSupportChatAdmin(selectedUser.user_mobile, message);
  };
  useEffect(() => {
    connectUserListWebSocket();
    return () => {
      if (userListSocketRef.current) {
        userListSocketRef.current.close();
        userListSocketRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    if (!selectedUser?.user_mobile) return;
    getSupportChatsAdmin(selectedUser.user_mobile);
    connectWebSocket(selectedUser.user_mobile);
    return () => {
      if (socketRef.current) {
        socketRef.current.close();
        socketRef.current = null;
      }
    };
  }, [selectedUser?.user_mobile]);
  const getTimeAgo = (dateStr) => {
    if (!dateStr) return "";
    const cleaned = dateStr.replace(" , ", " ");
    const [datePart, timePart, meridian] = cleaned.split(" ");
    if (!datePart || !timePart || !meridian) return dateStr;
    const [day, month, year] = datePart.split("-").map(Number);
    let [hours, minutes, seconds] = timePart.split(":").map(Number);
    if (
      isNaN(day) ||
      isNaN(month) ||
      isNaN(year) ||
      isNaN(hours) ||
      isNaN(minutes)
    ) {
      return dateStr;
    }
    if (meridian === "PM" && hours !== 12) hours += 12;
    if (meridian === "AM" && hours === 12) hours = 0;
    const messageDate = new Date(
      year,
      month - 1,
      day,
      hours,
      minutes,
      seconds || 0
    );
    if (isNaN(messageDate.getTime())) return dateStr;
    const now = new Date();
    const diffMs = now - messageDate;
    if (diffMs < 0) return "Just now";
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);
    if (diffSec < 60) return "Just now";
    if (diffMin < 60) return `${diffMin} min ago`;
    if (diffHr < 24) return `${diffHr} hrs ago`;
    if (diffDay === 1) return "Yesterday";
    if (diffDay < 7) return `${diffDay} days ago`;
    return messageDate.toLocaleDateString();
  };
  useEffect(() => {
    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, []);
  return (
    <div className="mt-3" style={{ height: "90vh", overflow: "hidden" }}>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          <img src={loaderGif} alt="Loading..." style={{ width: "9rem" }} />
        </div>
      ) : (
        <Row className="h-100 p-0">
          <Col
            md={3}
            className="border-end h-100 overflow-auto"
            style={{ scrollbarWidth: "none" }}
          >
            <h5>Support Chat</h5>
            <Form.Control
              type="text"
              placeholder="Search by name or ID..."
              className="mb-3"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {(filteredUserList || []).map((u) => {
              const isOpenChat =
                selectedUser?.user_mobile &&
                selectedUser.user_mobile === u?.user_mobile;
              const initials =
                u?.user_name
                  ?.split(" ")
                  .map((n) => n[0])
                  .join("")
                  .toUpperCase() || "U";

              return (
                <div
                  key={u?.id}
                  className={`d-flex align-items-center mb-2 p-2 user-tab ${
                    isOpenChat ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedUser(u);
                    if (u?.user_mobile) getSupportChatsAdmin(u.user_mobile);
                  }}
                  style={{ cursor: "pointer", borderRadius: 5 }}
                >
                  <div className="avatar bg-success text-white fw-bold me-2">
                    {initials}
                  </div>
                  &nbsp;
                  <div className="support-user-info">
                    <span>{u?.user_name || "Unnamed"}</span>
                  </div>
                </div>
              );
            })}
          </Col>

          <Col md={9} className="h-100 d-flex flex-column">
            {selectedUser ? (
              <>
                <div className="d-flex align-items-center border-bottom p-3">
                  <div className="avatar bg-success text-white fw-bold me-2">
                    {selectedUser.user_name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")}
                  </div>{" "}
                  &nbsp;
                  <h5 className="mb-0">{selectedUser.user_name}</h5>
                </div>

                <div className="flex-grow-1 p-3 chat-body overflow-auto">
                  {(messages || []).map((msg, idx) => {
                    const isReceived = msg?.sender === "RECEIVED";

                    return (
                      <div
                        key={idx}
                        className={`d-flex mb-2 ${
                          isReceived
                            ? "justify-content-end" 
                            : "justify-content-start" 
                        }`}
                      >
                        {!isReceived && (
                          <div className="avatar bg-success text-white fw-bold ms-2">
                            {selectedUser?.user_name
                              ?.charAt(0)
                              ?.toUpperCase() || "U"}
                          </div>
                        )}
                     

                        <div>
                          <div
                            className={`rounded px-3 py-1 mb-1 ${
                              isReceived ? "bg-light text-dark" : "bg-light"
                            }`}
                          >
                            {msg?.text}
                          </div>
                          <small className="text-muted d-block text-end">
                            {getTimeAgo(msg?.time)}
                          </small>
                        </div>

                        {isReceived && (
                          <div className="avatar bg-warning text-white fw-bold me-2">
                            C
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div className="border-top p-3">
                  <InputGroup>
                    <Form.Control
                      placeholder="Type your message..."
                      value={inputMessage}
                      onChange={(e) => setInputMessage(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleSend()}
                    />
                    <Button variant="primary" onClick={handleSend}>
                      ➤
                    </Button>
                  </InputGroup>
                </div>
              </>
            ) : (
              <div className="d-flex justify-content-center align-items-center h-100">
                <p>Select a user to start chatting</p>
              </div>
            )}
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Support;
